<template>
	<div class="scroll-area-wrapper" :class="{'fade' : fadeVisible}">
		<vue-custom-scrollbar
			class="scroll-area"
			:settings="settings"
			@ps-scroll-up="scrollUp"
			@ps-y-reach-end="reachedEnd">
			<slot></slot>
		</vue-custom-scrollbar>
	</div>
</template>

<script>
import vueCustomScrollbar from 'vue-custom-scrollbar'

export default {
  props: {
    showFade: {
      type: Boolean,
      default: true
    }
  },
  components: {
    vueCustomScrollbar
  },
  data () {
    return {
      fadeToggle: true,
      settings: {
        maxScrollbarLength: 120,
        fade: true
      }
    }
  },
  computed: {
    fadeVisible: function () {
      if (!this.showFade) return false
      return this.fadeToggle
    }
  },
  methods: {
    reachedEnd (event) {
      this.fadeToggle = false
      this.$emit('ps-y-reach-end', event)
    },
    scrollUp (event) {
      this.fadeToggle = true
    }
  }
}
</script>

<style>
.scroll-area .ps__rail-x,
.scroll-area .ps__rail-y { opacity: .1; z-index: 100; }

.scroll-area-wrapper {
	position: relative;
}

.scroll-area-wrapper.fade:after {
	content: "";
	position: absolute;
	z-index: 1;
	bottom: 0;
	left: 0;
	pointer-events: none;
	background-image: linear-gradient(to bottom, rgba(255, 255, 255, 0), rgba(255, 255, 255, 1) 90%);
	width: 100%;
	height: 4em;
	transition: opacity .2s ease-in-out;
}
</style>



// WEBPACK FOOTER //
// src/components/Elements/CustomScrollbar.vue